(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4648],{

/***/ 69192:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/information/[slugOrId]",
      function () {
        return __webpack_require__(18108);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);








var Breadcrumb = function(_param) {
    var _theme = _param.theme, theme = _theme === void 0 ? "light-bg" : _theme, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "theme"
    ]);
    var textColor = theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.text */ .O9.text : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.white00 */ .O9.white00;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ol", {
        itemScope: true,
        itemType: "https://schema.org/BreadcrumbList",
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("margin:0;padding:0;display:flex;align-items:center;color:", textColor, ";font-size:11px;line-height:1.45;li:not(:last-child)::after{content:'/';margin:0 5px;color:", theme === "light-bg" ? plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.gray70 */ .O9.gray70 : plume_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.border */ .O9.border, ";font-size:11px;line-height:1.45;}a{transition:text-decoration 0.2s ease;text-decoration:underline solid transparent;:hover{text-decoration:underline solid ", textColor, ";}}a:visited,a:link{color:", textColor, ";}"),
        className: props.className,
        children: props.children.map(function(component, i) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("li", {
                    itemProp: "itemListElement",
                    itemScope: true,
                    itemType: "https://schema.org/ListItem",
                    children: [
                        component,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("meta", {
                            itemProp: "position",
                            content: i + 1 + ""
                        })
                    ]
                })
            }, i);
        })
    });
};
var BreadcrumbLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("a", {
            itemProp: "item",
            className: props.className,
            target: props.external ? "_blank" : "_top",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                itemProp: "name",
                children: props.children
            })
        })
    }));
};
var BreadcrumbItem = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
        itemProp: "name",
        className: props.className,
        children: props.children
    });
};


/***/ }),

/***/ 14380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FormattedDate; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lib_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57923);
/* harmony import */ var _lib_wovn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15598);




// Returns formatted date of iso string
var FormattedDate = function(props) {
    if (!props.children) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
        className: props.className,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
            className: _lib_wovn__WEBPACK_IMPORTED_MODULE_2__/* .IGNORED_BY_WOVN_CLASS_NAME */ .Y,
            suppressHydrationWarning: true,
            children: (0,_lib_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(props.children, "yyyy/MM/dd")
        })
    });
};


/***/ }),

/***/ 71439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ MarkdownImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);






var MarkdownImage = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "out-set" : _type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "type"
    ]);
    if (type === "full-column") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(FullColumnImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("vertical-align:bottom;")
    }));
};
var FullColumnImage = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)("padding:0;vertical-align:bottom;", plume_ui__WEBPACK_IMPORTED_MODULE_0__.mq.large, "{border:none !important;padding-left:48px;padding-right:48px;}")
    }, props));
};


/***/ }),

/***/ 13896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ MarkdownTextDivider; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4807);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var MarkdownTextDivider = function() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .Divider */ .iz, {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_0__/* .colors.gray60 */ .O9.gray60, ";margin:45px 20px;width:55px;", plume_ui__WEBPACK_IMPORTED_MODULE_0__.mq.large, "{margin:45px 48px;}")
    });
};


/***/ }),

/***/ 67014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ desktopMaxWidth; },
/* harmony export */   "n": function() { return /* binding */ desktopMinWidth; }
/* harmony export */ });
var desktopMaxWidth = "769px";
var desktopMinWidth = "770px";


/***/ }),

/***/ 11566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gs": function() { return /* binding */ isText; },
/* harmony export */   "LV": function() { return /* binding */ stripMarkdown; },
/* harmony export */   "Or": function() { return /* binding */ isImage; },
/* harmony export */   "jY": function() { return /* binding */ isImageLink; },
/* harmony export */   "sQ": function() { return /* binding */ isAnchorImage; }
/* harmony export */ });
var stripMarkdown = function(text) {
    var linkRegex = /\[(.*?)\][\[\(].*?[\]\)]/g;
    return text.replace(linkRegex, "$1");
};
var isText = function(node) {
    return Array.isArray(node) && typeof node[0] === "string";
};
var isImageLink = function(node) {
    return Array.isArray(node) && node.some(isImage);
};
var isImage = function(node) {
    return typeof node === "object" && node.hasOwnProperty("props") && node.props.hasOwnProperty("src");
};
var isAnchorImage = function(node) {
    return typeof node === "object" && node.hasOwnProperty("props") && node.props.hasOwnProperty("href") && node.props.children.some(isImage);
};


/***/ }),

/***/ 15598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ IGNORED_BY_WOVN_CLASS_NAME; }
/* harmony export */ });
var IGNORED_BY_WOVN_CLASS_NAME = "wovn-ignore";


/***/ }),

/***/ 61753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33431);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70917);
/* harmony import */ var plume_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4807);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56902);
/* harmony import */ var _lib_gtm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11543);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18584);
/* harmony import */ var _components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96747);













var Error = function(param) {
    var _statusCode = param.statusCode, statusCode = _statusCode === void 0 ? 404 : _statusCode, err = param.err;
    var msg = msgOf(statusCode);
    var user = (0,_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var errorMessage = "".concat(err === null || err === void 0 ? void 0 : err.name, " ").concat(err === null || err === void 0 ? void 0 : err.message);
        console.log("error", errorMessage);
        (0,_lib_gtm__WEBPACK_IMPORTED_MODULE_5__/* .pushEventToGTM */ .K)(user, _lib_tracking__WEBPACK_IMPORTED_MODULE_4__/* .ERROR */ .pn, errorMessage);
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_common_Template__WEBPACK_IMPORTED_MODULE_1__/* .Template */ .Y, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("div", {
            css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("text-align:center;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.black30 */ .O9.black30, ";padding:0 15px;"),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    id: "error-page-error-code",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:100px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.statusCodeForDisplay
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("font-size:28px;font-weight:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .font.weight.normal */ .LZ.weight.normal, ";"),
                    children: msg.title
                }),
                msg.image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("img", {
                    src: msg.image,
                    alt: "Error Image",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-top:64px;}width:240px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{width:320px;}")
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.textLight */ .O9.textLight, ";font-size:16px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{font-size:18px;}"),
                    "data-test-id": "error-page-description",
                    children: msg.description
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("a", {
                        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("margin-top:40px;margin-bottom:40px;", plume_ui__WEBPACK_IMPORTED_MODULE_2__.mq.large, "{margin-bottom:64px;}display:flex;align-items:center;justify-content:center;"),
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_atoms_IcomoonIcon__WEBPACK_IMPORTED_MODULE_7__/* .IcomoonIcon */ .g, {
                                name: "arrow-back",
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;padding-right:4px;")
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("span", {
                                css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__/* .css */ .iv)("color:", plume_ui__WEBPACK_IMPORTED_MODULE_2__/* .colors.link */ .O9.link, ";font-size:14px;"),
                                children: "トップに戻る"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var msgOf = function(statusCode) {
    switch(statusCode){
        case 403:
            return {
                title: "FORBIDDEN",
                description: "このページへのアクセスは禁止されています。"
            };
        case 404:
            return {
                image: "/static/images/error/illust-404.png",
                description: "お探しのページは見つかりませんでした。"
            };
        case 500:
        default:
            return {
                statusCodeForDisplay: 500,
                title: "INTERNAL SERVER ERROR"
            };
    }
};
var handleTrailingSlash = function(req, res) {
    if (req.url) {
        var urlParts = req.url.split("?");
        if (urlParts[0].endsWith("/")) {
            urlParts[0] = urlParts[0].substring(0, urlParts[0].length - 1);
            res.writeHead(301, {
                Location: urlParts.join("?")
            });
            res.end();
        }
    }
};
Error.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(ctx) {
        var req, res, err, statusCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
            req = ctx.req, res = ctx.res, err = ctx.err;
            statusCode = res ? res.statusCode : err ? err.statusCode : 404;
            if (statusCode === 404 && req && res) {
                handleTrailingSlash(req, res);
            }
            if (res) {
                // Running on the server
                if (statusCode === 404) {
                    return [
                        2,
                        {
                            statusCode: 404
                        }
                    ];
                }
            }
            return [
                2,
                {
                    statusCode: statusCode,
                    err: err
                }
            ];
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (Error);


/***/ }),

/***/ 18108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _slugOrId_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./lib/api/contentful.ts
var contentful = __webpack_require__(58585);
// EXTERNAL MODULE: ./lib/log.ts
var log = __webpack_require__(79240);
// EXTERNAL MODULE: ./lib/url.ts
var url = __webpack_require__(48261);
;// CONCATENATED MODULE: ./lib/notice.ts







var toScope = function(role) {
    switch(role){
        case "member":
        case "trial":
            return "login";
        case "enterprise":
        case "moderator":
            return "enterprise";
    }
    // For safe, fallback to 'all' scope (handled as guests)
    return "all";
};
var order = [
    "none",
    "enterprise",
    "login",
    "all"
];
var toIndex = function(scope) {
    var index = order.indexOf(scope);
    // For safe, fallback to 'none' scope (don't show anyway)
    return index === -1 ? 0 : index;
};
var allowedScopes = function(user) {
    return user ? order.slice(toIndex(toScope(user.role))) : [
        "all"
    ];
};
var fetchNotices = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(user) {
        var notices, items, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    notices = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,contentful/* getNotices */.r7)(allowedScopes(user))
                    ];
                case 2:
                    items = _state.sent();
                    notices = items.map(function(item) {
                        return convertNotice((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.fields), {
                            id: item.sys.id
                        }));
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        notices
                    ];
            }
        });
    });
    return function fetchNotices(user) {
        return _ref.apply(this, arguments);
    };
}();
var fetchLatestNotice = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var notices, items, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    notices = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,contentful/* getNotices */.r7)(allowedScopes())
                    ];
                case 2:
                    items = _state.sent();
                    notices = items.map(function(item) {
                        return convertNotice((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.fields), {
                            id: item.sys.id
                        }));
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        notices[0] || null
                    ];
            }
        });
    });
    return function fetchLatestNotice() {
        return _ref.apply(this, arguments);
    };
}();
var fetchEnterpriseNotices = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var notices, items, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    notices = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,contentful/* getEnterpriseNotices */.Jo)()
                    ];
                case 2:
                    items = _state.sent();
                    notices = items.map(function(item) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.fields), {
                            id: item.sys.id
                        });
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        notices
                    ];
            }
        });
    });
    return function fetchEnterpriseNotices() {
        return _ref.apply(this, arguments);
    };
}();
var fetchNotice = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(slugOrId) {
        var notice, contentfulNotice, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,contentful/* getNotice */.uT)(slugOrId)
                    ];
                case 1:
                    contentfulNotice = _state.sent();
                    notice = convertNotice(contentfulNotice);
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    (0,log/* printError */.O)(e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        notice
                    ];
            }
        });
    });
    return function fetchNotice(slugOrId) {
        return _ref.apply(this, arguments);
    };
}();
var convertNotice = function(contentfulNotice) {
    var headerImage = {
        url: (0,url/* withProtocol */.Ac)(contentfulNotice.headerImage.fields.file.url),
        title: contentfulNotice.headerImage.fields.title
    };
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contentfulNotice), {
        headerImage: headerImage
    });
};

// EXTERNAL MODULE: ./components/common/MarkdownImage.tsx
var MarkdownImage = __webpack_require__(71439);
// EXTERNAL MODULE: ./components/common/MarkdownTextDivider.tsx
var MarkdownTextDivider = __webpack_require__(13896);
// EXTERNAL MODULE: ./lib/markdown.ts
var markdown = __webpack_require__(11566);
// EXTERNAL MODULE: ./node_modules/markdown-to-jsx/dist/index.modern.js
var index_modern = __webpack_require__(35576);
// EXTERNAL MODULE: ./node_modules/plume-ui/dist/index.js
var dist = __webpack_require__(4807);
// EXTERNAL MODULE: ./node_modules/react-anchor-link-smooth-scroll/lib/anchor-link.js
var anchor_link = __webpack_require__(84925);
var anchor_link_default = /*#__PURE__*/__webpack_require__.n(anchor_link);
;// CONCATENATED MODULE: ./components/pages/information/Markdown.tsx










var paddingSm = 24;
var paddingLg = 48;
var listMarkerPadding = 25;
var paddingSmartphoneStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:", paddingSm, "px;padding-right:", paddingSm, "px;");
var paddingDesktopStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-left:", paddingLg, "px;padding-right:", paddingLg, "px;");
var bodyMdStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("& img{width:100vw;}", dist.mq.large, "{& img{width:100%;}}& p{font-size:15px;line-height:1.75;letter-spacing:0.02em;color:", dist/* colors.black30 */.O9.black30, ";", dist.mq.large, "{margin:32px 0;font-size:16px;line-height:2;}}& h1{line-height:1.3;", paddingSmartphoneStyle, ";", dist.mq.large, "{", paddingDesktopStyle, ";}}& h2{font-size:18px;margin-top:48px;margin-bottom:16px;line-height:1.5;letter-spacing:0.02em;", paddingSmartphoneStyle, ";", dist.mq.large, "{margin-top:64px;font-size:20px;line-height:1.75;", paddingDesktopStyle, ";}}& div + pre{margin-top:-15px;}");
var BodyMarkdown = function(props) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_modern/* default */.ZP, {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(bodyMdStyle, ";margin-top:", props.shrink ? "16px" : "60px", ";margin-bottom:40px;", dist.mq.large, "{margin-bottom:64px;}p{", paddingSmartphoneStyle, ";", dist.mq.large, "{", paddingDesktopStyle, ";}}ul{margin:16px 0;padding-left:calc(", paddingSm, "px + ", listMarkerPadding, "px);padding-right:", paddingSm, "px;", dist.mq.large, "{padding-left:calc(", paddingLg, "px + ", listMarkerPadding, "px);padding-right:", paddingLg, "px;}/* nested list style */\n          ul{padding-left:", paddingSm, "px !important;padding-right:0;", dist.mq.large, "{children:React.ReactNode\n              padding-left:", paddingLg, "px !important;padding-right:0;}}li{list-style:initial;line-height:2;letter-spacing:0.02em;}}"),
        options: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.options), {
            overrides: (0,_object_spread/* default */.Z)({
                a: Link,
                code: Annotation,
                blockquote: BodyFootnote,
                iframe: IFrame,
                h2: Heading,
                p: PorDiv,
                img: MarkdownImage/* MarkdownImage */.k,
                Image: MarkdownImage/* MarkdownImage */.k,
                hr: MarkdownTextDivider/* MarkdownTextDivider */.n
            }, (ref = props.options) === null || ref === void 0 ? void 0 : ref.overrides)
        }),
        children: props.children
    });
};
var Annotation = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;color:", dist/* colors.textLight */.O9.textLight, ";font-size:12px;line-height:1.5;letter-spacing:0.02em;", dist.mq.large, "{font-size:14px;line-height:1.75;}"),
        children: props.children
    });
};
var BodyFootnote = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("pre", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&&{margin:8px 24px 0;white-space:pre-line;word-break:break-all;font-family:", dist/* font.family */.LZ.family, ";text-align:center;p{color:", dist/* colors.textLight */.O9.textLight, ";padding:0;margin:0;font-size:12px;line-height:1.75;letter-spacing:0.02em;& a{color:", dist/* colors.link */.O9.link, ";font-weight:", dist/* font.weight.normal */.LZ.weight.normal, ";border-bottom:none;padding-bottom:0;margin:0;}}", dist.mq.large, "{margin:8px 48px 0;p{font-size:14px;}}}"),
        children: props.children
    });
};
var PorDiv = function(props) {
    return props.children.some(function(node) {
        return (0,markdown/* isImage */.Or)(node) || (0,markdown/* isAnchorImage */.sQ)(node);
    }) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread/* default */.Z)({
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("& > img{display:block;}& > a{border-bottom:none;margin:0;}")
    }, props)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", (0,_object_spread/* default */.Z)({}, props));
};
// NOTE: Drop other attributes (allowtransparency, mozallowfullscreen, ...) to avoid errors from React.
var IFrame = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-color:transparent;overflow:hidden;", iframeCss(props.src)),
        id: props.id,
        src: props.src,
        frameBorder: "0",
        allowFullScreen: true
    });
};
var iframeCss = function(src) {
    if (src.includes("//speakerdeck.com/player")) {
        // for SpeakerDeck
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&&&&{margin:20px 5px;width:calc(100% - 10px);height:calc(100vw * 0.562);", dist.mq.large, "{margin:20px 0;width:100%;height:calc(770px * 0.562);}}");
    } else {
        // for Google Slide, Datawrapper (charts), etc.
        return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("&&&&{margin:20px 0;width:100%;height:auto;min-height:350px;}");
    }
};
var Heading = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h2", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                id: "".concat(props.children),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;top:-65px;")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: props.children
            })
        ]
    });
};
var Link = function(props) {
    if (props.href.startsWith("#")) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WithinPageLink, (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExternalLink, (0,_object_spread/* default */.Z)({}, props));
};
var WithinPageLink = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((anchor_link_default()), {
        href: props.href,
        className: isText(props.children) ? "text-link" : undefined,
        css: linkCss(),
        children: props.children
    });
};
var ExternalLink = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
        href: props.href,
        target: "_blank",
        className: isText(props.children) ? "text-link" : undefined,
        css: linkCss(),
        children: props.children
    });
};
var isText = function(node) {
    return Array.isArray(node) && typeof node[0] === "string";
};
var linkCss = function() {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.link */.O9.link, ";overflow-wrap:break-word;padding-bottom:1px;margin:0 2px;&:hover{text-decoration:underline;}&:focus{outline:none;}");
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/tokens/mediaquery.ts
var mediaquery = __webpack_require__(67014);
// EXTERNAL MODULE: ./components/atoms/FormattedDate.tsx
var FormattedDate = __webpack_require__(14380);
;// CONCATENATED MODULE: ./components/pages/information/NoticePublishedTime.tsx






var NoticePublishedTime = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:", dist/* colors.textLight */.O9.textLight, ";font-size:14px;letter-spacing:0.02em;line-height:1.5;@media (min-width:", mediaquery/* desktopMinWidth */.n, "){font-size:16px;}"),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormattedDate/* FormattedDate */.J, {
                children: props.publishedAt
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/information/Title.tsx





var Title = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:8px 0 0;line-height:1.5;letter-spacing:0.01em;@media (max-width:", mediaquery/* desktopMaxWidth */.g, "){font-size:20px;}@media (min-width:", mediaquery/* desktopMinWidth */.n, "){font-size:28px;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_modern/* default */.ZP, {
            options: {},
            children: props.text
        })
    });
};

// EXTERNAL MODULE: ./components/atoms/Breadcrumb.tsx
var Breadcrumb = __webpack_require__(56894);
;// CONCATENATED MODULE: ./components/pages/information/Heading.tsx









var Heading_Heading = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding-bottom:130px;background:", dist/* colors.brown30 */.O9.brown30, ";", dist.mq.large, "{padding-bottom:340px;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Breadcrumb/* Breadcrumb */.aG, {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:1116px;margin:0 auto;padding-top:16px;", dist.mq.untilLarge, "{display:none;}"),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbLink */.At, {
                        href: url/* enterpriseUrl */.t8,
                        external: true,
                        children: "ホーム"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbItem */.gN, {
                        children: "お知らせ"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Breadcrumb/* BreadcrumbItem */.gN, {
                        children: props.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("@media (max-width:", mediaquery/* desktopMaxWidth */.g, "){margin:0;padding:16px 24px 0;}@media (min-width:", mediaquery/* desktopMinWidth */.n, "){width:100%;max-width:730px;margin:38px auto 0;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:640px;margin:0 auto;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoticePublishedTime, {
                            publishedAt: props.publishedAt
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                            text: props.title
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./pages/_error.tsx
var _error = __webpack_require__(61753);
// EXTERNAL MODULE: ./components/common/Head.tsx
var Head = __webpack_require__(12912);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/common/Footer.tsx
var Footer = __webpack_require__(26123);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/Logo.tsx
var Logo = __webpack_require__(80774);
// EXTERNAL MODULE: ./components/atoms/IcomoonIcon.tsx
var IcomoonIcon = __webpack_require__(96747);
// EXTERNAL MODULE: ./components/pages/enterprise/EnterpriseButton.tsx
var EnterpriseButton = __webpack_require__(49850);
// EXTERNAL MODULE: ./components/view/MobileSideMenu.tsx
var MobileSideMenu = __webpack_require__(98347);
;// CONCATENATED MODULE: ./components/pages/enterprise/Header.tsx













var Header = function(props) {
    var requestId = react.useRef(0);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), scrollPosition = ref[0], setScrollPosition = ref[1];
    var checkScrollPosition = function() {
        requestId.current = requestAnimationFrame(checkScrollPosition);
        setScrollPosition(0 < window.scrollY);
    };
    react.useEffect(function() {
        checkScrollPosition();
        return function() {
            return cancelAnimationFrame(requestId.current);
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("header", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;top:0;z-index:40;width:100%;"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                scrollPosition: scrollPosition
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileHeader, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                scrollPosition: scrollPosition
            }))
        ]
    });
};
var ENTERPRISE_DESKTOP_HEADER_HEIGHT = "72px";
var DesktopHeader = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;background-color:", props.background || props.scrollPosition ? dist/* colors.white00 */.O9.white00 : "transparent", ";border-bottom:1px solid\n          ", props.background || props.scrollPosition ? dist/* colors.borderLight */.O9.borderLight : "transparent", ";width:100%;height:", ENTERPRISE_DESKTOP_HEADER_HEIGHT, ";transition:background-color 0.3s;", dist.mq.untilMedium, "{display:none;}"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;justify-content:space-between;width:100%;max-width:1440px;margin-inline:auto;padding-inline:40px;"),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("nav", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;display:flex;align-items:center;"),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: url/* enterpriseUrl */.t8,
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* FullColorLogo */.Jq, {
                                        size: Logo/* LOGO_SIZE.SMALL */.nZ.SMALL
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;display:flex;grid-column-gap:32px;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderLink, {
                                    href: url/* enterpriseUrl */.t8,
                                    active: props.activeTab === "features",
                                    children: "Speedaとは"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderLink, {
                                    href: url/* customerInterviewsUrl */.pD,
                                    active: props.activeTab === "customers",
                                    children: "導入事例"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderLink, {
                                    href: url/* seminarsUrl */.to,
                                    active: props.activeTab === "events",
                                    children: "セミナー・イベント"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderLink, {
                                    href: url/* resourcesUrl */.li,
                                    active: props.activeTab === "resources",
                                    children: "資料・レポート"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;display:flex;grid-column-gap:8px;"),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnterpriseButton/* EnterpriseButton */.J, {
                            href: url/* trialRequestUrl */.d1,
                            external: true,
                            type: "outline",
                            "data-testid": "trial-page-button",
                            children: "無料トライアル"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnterpriseButton/* EnterpriseButton */.J, {
                            href: url/* downloadDocumentUrl */.Qf,
                            external: true,
                            children: "資料ダウンロード"
                        })
                    ]
                })
            ]
        })
    });
};
var ENTERPRISE_MOBILE_HEADER_HEIGHT = "56px";
var MobileHeader = function(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), sideMenuOpened = ref[0], setSideMenuOpened = ref[1];
    var toggleIsOpen = function() {
        setSideMenuOpened(!sideMenuOpened);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:relative;background-color:", props.background || props.scrollPosition ? dist/* colors.white00 */.O9.white00 : "transparent", ";width:100%;height:", ENTERPRISE_MOBILE_HEADER_HEIGHT, ";padding-block:16px;padding-inline:24px;border-bottom:1px solid\n          ", props.background || props.scrollPosition ? dist/* colors.border */.O9.border : "transparent", ";", dist.mq.large, "{display:none;}"),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: url/* enterpriseUrl */.t8,
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                        target: "_blank",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo/* FullColorLogo */.Jq, {
                            size: Logo/* LOGO_SIZE.SMALL */.nZ.SMALL
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                onClick: toggleIsOpen,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background:0;border:0;position:absolute;right:0;top:0;padding-block:16px;padding-inline:16px;cursor:pointer;"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcomoonIcon/* IcomoonIcon */.g, {
                    name: "menu",
                    label: "メニューを開く",
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("font-size:24px;")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileSideMenu/* MobileSideMenu */.o, {
                isOpen: sideMenuOpened,
                toggleIsOpen: toggleIsOpen,
                pageType: "enterprise"
            })
        ]
    });
};
var HeaderLink = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
            href: props.href,
            passHref: true,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                target: "_blank",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;align-items:center;padding-block:15px;font-size:14px;line-height:1.25;letter-spacing:0.02em;color:", dist/* colors.text */.O9.text, ";border-bottom:2px solid\n              ", props.active ? dist/* colors.borderStrong */.O9.borderStrong : "transparent", ";&:hover{border-bottom-color:", dist/* colors.borderStrong */.O9.borderStrong, ";}"),
                children: props.children
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pages/enterprise/templates/EnterpriseTemplate.tsx







var EnterpriseTemplate = function(_param) {
    var _withHeaderBackground = _param.withHeaderBackground, withHeaderBackground = _withHeaderBackground === void 0 ? true : _withHeaderBackground, props = (0,_object_without_properties/* default */.Z)(_param, [
        "withHeaderBackground"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
                activeTab: props.activeTab,
                background: withHeaderBackground
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin-top:", withHeaderBackground ? "70px" : "0", ";", dist.mq.untilMedium, "{margin-top:", withHeaderBackground ? "55px" : "0", ";}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                    children: props.children
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* Footer */.$, {
                noBorder: true
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/information/[slugOrId].tsx












var NoticePage = function(props) {
    if (!props.notice || !props.notice.body) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_error["default"], {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EnterpriseTemplate, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Head/* NoticeHead */.iG, {
                notice: props.notice
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading_Heading, {
                title: props.notice.title,
                publishedAt: props.notice.publishedAt,
                headerImage: props.notice.headerImage
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:-107px 24px 32px;", dist.mq.large, "{margin:-300px auto 48px;max-width:816px;}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: props.notice.headerImage.url,
                    alt: props.notice.headerImage.title,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;border-radius:4px;")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BodyMarkdown, {
                    shrink: true,
                    children: props.notice.body
                })
            })
        ]
    });
};
var ContentWrapper = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread/* default */.Z)({
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("margin:0 auto;", dist.mq.large, "{max-width:736px;}")
    }, props));
};
NoticePage.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, slugOrId, notice;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query;
                    slugOrId = query.slugOrId;
                    return [
                        4,
                        fetchNotice(slugOrId)
                    ];
                case 1:
                    notice = _state.sent();
                    return [
                        2,
                        {
                            notice: notice
                        }
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var _slugOrId_ = (NoticePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8687,519,8674,8101,1890,774,3431,3954,9774,2888,179], function() { return __webpack_exec__(69192); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);